import { render, staticRenderFns } from "./OrderActionCancel.vue?vue&type=template&id=3bf7e8c4&"
import script from "./OrderActionCancel.vue?vue&type=script&lang=ts&"
export * from "./OrderActionCancel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports